<ng-container *ngIf="cs.vm$ | async as vm">
  <dgx-components-accordion-article-filter
    *sharedSectionLoading="!sharedSectionLoading && vm.categories.length"
    [categories]="vm.categories"
    [keyword]="vm.searchTerm"
    [quantity]="vm.quantity"
    [subcategories]="vm.subcategories"
  >
    <dgx-components-accordion-article-category-panel
      (selectedCategories)="cs.handleSelectedCategories($event)"
      [accordionArticleFilterCategory]="vm.categoryArticles"
    />
    <dgx-components-accordion-article-subcategory-panel
      *ngIf="vm.subcategoryArticles.items.length"
      (selectedSubcategories)="cs.handleSelectedSubcategories($event)"
      [accordionArticleFilterSubcategory]="vm.subcategoryArticles"
    />
  </dgx-components-accordion-article-filter>
</ng-container>
